export interface VoicesIssue {
  id: string
  /** e.g. "August 2026" — issues are monthly. */
  month: string
  title: string
  /** Who wrote it. Volunteer staff, named as they choose to be. */
  author: { name: string; role: string }
  /** The letter itself, one paragraph per entry. */
  paragraphs: string[]
  /** Archive items this issue points at, by id. */
  featured: string[]
  /** Product notes, written for members rather than as release notes. */
  updates: { title: string; body: string }[]
  /** Closing line, signed. */
  signoff: string
}

/**
 * The monthly letter, published here exactly as it goes out by email. One
 * issue at a time, with the back issues reachable beneath it.
 */
export const VOICES_ISSUES: VoicesIssue[] = [
  {
    id: 'v-2026-08',
    month: 'August 2026',
    title: 'The year nobody wrote down',
    author: { name: 'Marion A.', role: 'Volunteer, archive group' },
    paragraphs: [
      'Every month a few of us sit down with whatever has come in — a shoebox, a cassette, a photograph somebody found behind a frame — and try to work out what year it belongs to. Most months we manage it. This month we didn’t, twice.',
      'The first is a photograph of about twenty people outside a building that is definitely not Oak Street and definitely not Third. Somebody has written “summer” on the back and nothing else. If you recognise the doorway, you know more than all of us put together.',
      'The second is a recording. Four minutes, several voices, one of them telling a story about a van that broke down somewhere between here and the coast. We have transcribed what we can. Two of the voices we have named. The rest are waiting.',
      'A note on the thin years, since people keep asking. 1994 has two entries in it. 1995 has one. That isn’t neglect — those were the years the office moved twice and nobody was photographing anything. If you were around then, you are effectively the record.',
    ],
    featured: ['a-1996-tuesday', 'a-1998-group-tape', 'a-2012-halloween'],
    updates: [
      {
        title: 'Recordings can be read',
        body: 'Every recording now has a transcript, so you can read one without playing it.',
      },
      {
        title: 'Naming voices',
        body: 'If you recognise someone speaking on an old tape, you can say so the same way you would name a face.',
      },
    ],
    signoff: 'Thank you for reading. Write back if any of this jogs something loose.',
  },
  {
    id: 'v-2026-07',
    month: 'July 2026',
    title: 'Twenty-one people arrived in June',
    author: { name: 'Dev R.', role: 'Volunteer, archive group' },
    paragraphs: [
      'Twenty-one people joined in June, which is more than the three months before it combined. Nine of them came from the 1980s, which was, until this spring, the emptiest decade we had.',
      'What that means in practice: the camp photographs finally have names on them. Not all of them. But the van, the first summer, and both of the kitchen pictures are now fully identified, and they were not in April.',
    ],
    featured: ['a-1986-van', 'a-1984-newsletter'],
    updates: [
      {
        title: 'Memorial pages',
        body: 'When a member dies, their page stays and becomes a place to leave something you remember.',
      },
    ],
    signoff: 'More next month.',
  },
  {
    id: 'v-2026-06',
    month: 'June 2026',
    title: 'What the archive is for',
    author: { name: 'Marion A.', role: 'Volunteer, archive group' },
    paragraphs: [
      'Somebody asked us last month why we bother scanning a flyer for a Halloween party in 2012. Fair question. The answer is that in thirty years it will be the only evidence that the party happened at all, and somebody will want to know.',
    ],
    featured: ['a-2012-halloween'],
    updates: [],
    signoff: 'That’s all for this month.',
  },
]
